import React from "react";

import { cn } from "../../lib/utils";

const MainContainer = ({ children, className }) => {
  return (
    <div
      className={cn("flex h-full flex-1 flex-col overflow-hidden", className)}
    >
      {children}
    </div>
  );
};

export default MainContainer;
